import React, { createContext, useState } from "react";

export const NavContext = createContext(0);

const NavProvider = ({children}) => {
  const [barHeight,setBarHeight] = useState(0);
  return <NavContext.Provider value={{barHeight,setBarHeight}}>{children}</NavContext.Provider>
}

export default NavProvider;